import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

type CapacitorWindow = Window & {
  Capacitor?: { platform?: string };
};

export const env = createEnv({
  server: {
    COOKIES_PASSWORD: z.string().min(32),
    OSN_ENVIRONMENT: z.enum(["development", "demo", "production", "backend"]).default("development"),
    OSN_DISCOVERY_API_ADDRESS: z.string().url().optional(),
  },
  client: {
    NEXT_PUBLIC_API_BASE_ADDRESS: z.string().url().optional(),
    NEXT_PUBLIC_SCHEDULES_API_BASE_ADDRESS: z.string().url().optional(),
    NEXT_PUBLIC_FIREBASE_API_KEY: z.string().min(1),
    NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_SERVICE_NAME: z.string().min(1).optional(),
    NEXT_PUBLIC_TENANT_ID: z.string().min(1).optional(),
    NEXT_PUBLIC_TENANT_NAME: z.string().min(1).optional(),
    NEXT_PUBLIC_MUI_KEY: z.string().optional(),
    NEXT_PUBLIC_GA_ID: z.string().optional(),
    NEXT_PUBLIC_FULLCALENDAR_KEY: z.string(),
  },
  runtimeEnv: {
    COOKIES_PASSWORD: process.env.COOKIES_PASSWORD,
    OSN_ENVIRONMENT: process.env.OSN_ENVIRONMENT,
    OSN_DISCOVERY_API_ADDRESS: process.env.OSN_DISCOVERY_API_ADDRESS,
    NEXT_PUBLIC_API_BASE_ADDRESS: process.env.NEXT_PUBLIC_API_BASE_ADDRESS,
    NEXT_PUBLIC_SCHEDULES_API_BASE_ADDRESS: process.env.NEXT_PUBLIC_SCHEDULES_API_BASE_ADDRESS,
    NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    NEXT_PUBLIC_SERVICE_NAME: process.env.NEXT_PUBLIC_SERVICE_NAME,
    NEXT_PUBLIC_TENANT_ID: process.env.NEXT_PUBLIC_TENANT_ID,
    NEXT_PUBLIC_TENANT_NAME: process.env.NEXT_PUBLIC_TENANT_NAME,
    NEXT_PUBLIC_MUI_KEY: process.env.NEXT_PUBLIC_MUI_KEY,
    NEXT_PUBLIC_GA_ID: process.env.NEXT_PUBLIC_GA_ID,
    NEXT_PUBLIC_FULLCALENDAR_KEY: process.env.NEXT_PUBLIC_FULLCALENDAR_KEY,
  },
});

/**
 * Detect if running in Capacitor app (mobile)
 * Only runs on client side (checks window object)
 */
export function isCapacitorApp(): boolean {
  if (typeof window === "undefined") return false;
  return (window as CapacitorWindow).Capacitor?.platform !== undefined;
}

/**
 * Get app tenant ID for Capacitor or fallback
 * - App: returns NEXT_PUBLIC_TENANT_ID from build time
 * - Web: the tenant is resolved from the request host through discovery instead
 */
export function getAppTenantId(): string {
  if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_TENANT_ID) {
    return process.env.NEXT_PUBLIC_TENANT_ID;
  }
  return "gridiron";
}
